export const INTERACTIVE_ELEMENTS_SELECTOR = [
  'button:not([tabindex="-1"],[type="hidden"],[disabled])',
  'input:not([tabindex="-1"],[type="hidden"],[disabled])',
  'textarea:not([tabindex="-1"],[type="hidden"],[disabled])',
  'select:not([tabindex="-1"],[type="hidden"],[disabled])',
  'details:not([tabindex="-1"],[type="hidden"],[disabled])',
  '[tabindex]:not([tabindex="-1"],.sr-only,[type="hidden"],[disabled])',
].join(',');
